import React, { useContext, useEffect, useRef, useState } from 'react';
import { Popover, Spin } from 'antd';
import { TimeLogo } from 'assets/svg';
import dayjs from 'dayjs';
import ErrorBox from './ErrorBox/ErrorBox';
import { FilterContextData } from 'contexts/FilterContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { UPDATED_TILL_DATE_VIEWED } from 'utils/mixpanelEventNames';
import { useLocation } from 'react-router-dom';

function TimeStampNavbar() {
    const route = useLocation();
    const {
        setLatestUpdatedDate,
        latestDate,
        maxTimeStampData: data,
        maxTimeStampLoading: loading,
        maxTimeStampError: error,
    } = useContext(FilterContextData);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const latestDateForDifferentRoutes = getConfig('latestDateForDifferentRoutes', appConfig);

    useEffect(() => {
        findTheLatestDate(data);
    }, [data, route.pathname]);

    function findTheLatestDate(listOfData: any) {
        let latestEndTimestamp: any = null;
        if (Array.isArray(listOfData)) {
            const screenName = route.pathname?.slice(route.pathname?.lastIndexOf('/') + 1);
            const latestDataKey = latestDateForDifferentRoutes?.[screenName] || latestDateForDifferentRoutes?.default;
            const currentDataKey = listOfData?.find((item: any) => {
                return item?.tableName === latestDataKey;
            });
            const defaultDataKey = listOfData?.find((item: any) => {
                return item?.tableName === latestDateForDifferentRoutes?.default;
            });
            //if actual latest date is null, take default latest date
            latestEndTimestamp = currentDataKey?.endTimestamp ?? defaultDataKey?.endTimestamp;
        }
        const formattedDate = dayjs.unix(latestEndTimestamp).utc().format(commonConfig?.dateFormat);
        setLatestUpdatedDate(formattedDate);
    }

    if (error?.length) {
        return <ErrorBox />;
    }

    return (
        <div>
            <Popover
                onOpenChange={(visible) => {
                    if (visible) trackEventMixpanel(UPDATED_TILL_DATE_VIEWED);
                }}
                content={
                    <RenderList
                        format={commonConfig?.dateFormat}
                        listOfData={data?.filter((d: any) => d?.endTimestamp)}
                    />
                }
                placement={'bottom'}
                overlayInnerStyle={{ borderRadius: '5px' }}
            >
                <div className="rounded bg-bgBackground flex justify-center items-center p-1.5 cursor-pointer">
                    <span className="flex justify-center items-center gap-2 text-purpleFont font-xs font-normal">
                        <TimeLogo />
                        <span className="flex justify-center items-center gap-1">
                            <span>updated till: </span>
                            <span>
                                {loading ? (
                                    <span className="px-6 flex justify-center">
                                        <Spin size="small" />
                                    </span>
                                ) : data?.length ? (
                                    latestDate
                                ) : (
                                    ''
                                )}
                            </span>
                        </span>
                    </span>
                </div>
            </Popover>
        </div>
    );
}

export default TimeStampNavbar;

export function RenderList({ listOfData, format }: any) {
    return (
        <div>
            <ul className="font-xxs">
                {listOfData?.map((date: any, index: any) => {
                    return (
                        <li
                            className={`w-full flex justify-between items-center gap-2 ${
                                index != listOfData?.data?.getMaxTimeStamps.length - 1 && 'mb-1'
                            }`}
                        >
                            <span>{date.tableName}:</span>
                            <span className="font-medium">{dayjs.unix(date.endTimestamp).utc().format(format)}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
